import { ResourceProps } from 'react-admin';
import VPNShow from './VPNShow';
import VPNList from './VPNList';
import { SubMenu } from '../../constants/SubMenu';

const VpnResource: ResourceProps = {
  name: 'vpn',
  list: VPNList,
  show: VPNShow,
  options: {
    isVisible: (hasPermission: Function) => hasPermission('dev_options'),
    menu: SubMenu.Develop,
  },
};

export default VpnResource;
